import React, {useEffect, useState} from 'react';
import Box from '@mui/material/Box';
import {Typography} from "@mui/material";
import {GridLinkOperator} from '@mui/x-data-grid';
import {useAuth} from "../../_auth/useAuth";
import {homeCustomerColumns, homeBrokerColumns } from '../../_appData/grids';
import {
    DaGridSettings,
    MuiGridStateProp,
    MuiGridDataProp,
} from "../_shared";
import {IMuiDataRequest, customerApi, brokerApi} from "../../_api";
import {HomeViewGrid} from "./HomeViewGrid";



export const HomeView: React.FC = () => {
    const { isAuthenticated, getAccessToken } = useAuth();
    const [isListAdminLoading, setIsListAdminLoading] = useState<boolean>(true);
    const [listAdminGridState, setListAdminGridState] = useState<MuiGridStateProp>({
        page: 0,
        page_size: DaGridSettings.defaultPageSize,
        filters: {
            items: [],
            linkOperator: GridLinkOperator.Or
        },
        sorts: [],
    });
    const [listAdminData, setlistAdminData] = useState<MuiGridDataProp>({
        rows: [],
        row_count: 0,
    });
    const listAdminGridColVisibility = {broker_id: false, federal_tax_id: false}

    const [isCustomerLoading, setIsCustomerLoading] = useState<boolean>(true);
    const [customerGridState, setCustomerGridState] = useState<MuiGridStateProp>({
        page: 0,
        page_size: DaGridSettings.defaultPageSize,
        filters: {
            items: [],
            linkOperator: GridLinkOperator.Or
        },
        sorts: [],
    });
    const [customerData, setCustomerData] = useState<MuiGridDataProp>({
        rows: [],
        row_count: 0,
    });

    const customerGridColVisibility = {customer_id: false, federal_tax_id: false,}

    useEffect(() => {
        let  isActive = true;

        (async () => {
            // if authenticated, get data from remote service
            if (isAuthenticated) {
                await getListAdminData();
            }

            if (!isActive) {
                return;
            }
        })();

        return () => {
            isActive = false;
        };
    }, [isAuthenticated, listAdminGridState]);

    const getListAdminData = async () => {
        setIsListAdminLoading(true);

        const options: IMuiDataRequest = listAdminGridState;
        const auth_token = await getAccessToken();

        brokerApi.get(options, auth_token)
        .then((resp) => {
            if (resp && (resp as any).success) {
                // Flatten company and user fields for grid
                const rows = ((resp as any).data || []).map((row: any) => {
                    const company = row.company || {};
                    const user = row.user || {};
                    return {
                        ...row,
                        ...company,
                        representative_name: user.first_name && user.last_name ? `${user.first_name} ${user.last_name}` : user.first_name || company.representative_name || '',
                        representative_email: user.email || company.representative_email || '',
                        representative_title: user.title || company.representative_title || '',
                    };
                });
                setlistAdminData({ rows, row_count: (resp as any).count! });
            } else {
                setlistAdminData({ rows: [], row_count: 0 });
            }
        })
        .finally(() => {
            setIsListAdminLoading(false);
        });

    }

    useEffect(() => {
        let  isActive = true;

        (async () => {
            // if authenticated, get data from remote service
            if (isAuthenticated) {
                await getCustomerData();
            } else {
                setCustomerData({ rows: [], row_count: 0 });
                setIsCustomerLoading(false);
            }

            if (!isActive) {
                return;
            }
        })();

        return () => {
            isActive = false;
        };
    }, [isAuthenticated, customerGridState]);

    const getCustomerData = async () => {
        setIsCustomerLoading(true);

        const options: IMuiDataRequest = customerGridState;
        const auth_token = await getAccessToken();

        customerApi.get(options, auth_token)
        .then((resp) => {
            if (resp && (resp as any).success) {
                setCustomerData({ rows: (resp as any).data, row_count: (resp as any).count! });
            } else {
                setCustomerData({ rows: [], row_count: 0 });
            }
        })
        .finally(() => {
            setIsCustomerLoading(false);
        });
    }

    return (
        <Box sx={{ paddingTop: 3 }}>
            <Typography variant="h4">
                PAF Manager
            </Typography>
                {isAuthenticated ? (
                    <>
                        <Box sx={{ marginTop: 2 }}>
                            <HomeViewGrid
                                title={"Brokers/Agents"}
                                gridColumns={homeBrokerColumns}
                                gridRowIdColumn={"listadmin_id"}
                                gridData={listAdminData}
                                gridState={listAdminGridState}
                                setGridState={setListAdminGridState}
                                isGridLoading={isListAdminLoading}
                                columnVisibility={listAdminGridColVisibility}
                                containerStyle={{ height: 300, width: '100%',}}
                            />
                        </Box>
                        <Box sx={{ marginTop: 2 }}>
                            <HomeViewGrid
                                title={"Customers"}
                                gridColumns={homeCustomerColumns}
                                gridRowIdColumn={"company_id"}
                                gridData={customerData}
                                gridState={customerGridState}
                                setGridState={setCustomerGridState}
                                isGridLoading={isCustomerLoading}
                                columnVisibility={customerGridColVisibility}
                                containerStyle={{ height: 300, width: '100%',}}
                            />
                        </Box>
                    </>
                ) : (
                    <Typography variant="h5">Please Login to use this system...</Typography>
                )}
        </Box>
    );
}
